import {filter, is, join, pipe, unapply} from 'ramda'

export const joinClassNames = pipe(unapply(filter(is(String))), join(' '))